<template>
  <div class="vacancy-list-item" :class="{'no-active':vacancyList.allNotActive}">
    <div class="vacancy-list-item__wrap">
      <div class="vacancy-list-item__left-wrap">
        <div class="vacancy-list-item__qr-wrap">
          <VacancyListQr :vacancy-list-id="vacancyList.id" :url="showVacancyListUrl" />
        </div>
        <div class="vacancy-list-item__vacancy-wrap">
          <template>
            <div class="vacancy-list-item__title">
              <RouterLink class="mr-1" :to="getUpdateLink(vacancyList.id)">
                {{ vacancyListTitle }}
              </RouterLink>
              <a style="text-decoration: none" :href="showVacancyListUrl" target="_blank">
                <VIcon small color="primary">
                  mdi-open-in-new
                </VIcon>
              </a>
            </div>
            <!--            <div>-->
            <!--              {{ $t('filterTitle') }}: {{ $t(`filter.${vacancyList.type}`) }}-->
            <!--            </div>-->
          </template>
          <template v-if="vacancyList.vacancies">
            <div class="vacancy-list-item__list d-none d-md-block ">
              <div v-if="vacancyList.allNotActive" class="vacancy-list-item__list-error">
                <img src="../../assets/img/qr/alert.svg" alt="">
                <span class="vacancy-list-item__list-error-text">{{ $t('allVacanciesArchived') }}</span>
              </div>
              <div v-if="vacancyList.vacancies.length > 0">
                <div
                  class="vacancy-list-item__list-item"
                  v-for="vacancy of vacancyList.vacancies"
                  :key="vacancy.id"
                >
                  <div class="vacancy-list-item__list-caption">
                    <template>
                      <span :style="`color:${getFontColor(vacancy)}`">
                        {{ vacancy.title }}
                      </span>
                    </template>
                  </div>
                  <div v-if="vacancy.publishedTill" class="vacancy-list-item__list-value">
                    <template>
                      <div :style="`color:${getFontColor(vacancy)}`">
                        {{ $t('until') }} {{ getFormattedDate(vacancy.publishedTill) }}
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <div v-else>
                <div>
                  {{ $t('emptyVacancies') }}
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="vacancy-list-item__vacancy-wrap d-md-none">
        <template v-if="vacancyList.vacancies">
          <div class="vacancy-list-item__list ">
            <div v-if="vacancyList.allNotActive" class="vacancy-list-item__list-error">
              <img src="../../assets/img/qr/alert.svg" alt="">
              <span class="vacancy-list-item__list-error-text">{{ $t('allVacanciesArchived') }}</span>
            </div>
            <div v-if="vacancyList.vacancies.length > 0">
              <div
                class="vacancy-list-item__list-item"
                v-for="vacancy of vacancyList.vacancies"
                :key="vacancy.id"
              >
                <div class="vacancy-list-item__list-caption">
                  <template>
                    <div :style="`color:${getFontColor(vacancy)}`">
                      {{ vacancy.title }}
                    </div>
                  </template>
                </div>
                <div v-if="vacancy.publishedTill" class="vacancy-list-item__list-value">
                  <template>
                    <div :style="`color:${getFontColor(vacancy)}`">
                      {{ $t('until') }} {{ getFormattedDate(vacancy.publishedTill) }}
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div v-else>
              <div>
                {{ $t('emptyVacancies') }}
              </div>
            </div>
          </div>
        </template>
      </div>
      <VacancyListQrLinks
        :url="showVacancyListUrl"
        :vacancy-list-id="vacancyList.id"
        @getUpdateLink="getUpdateLink"
        @toggleVacancyListSocialDialog="toggleVacancyListSocialDialog"
        @toggleVacancyListDeleteDialog="toggleVacancyListDeleteDialog"
      />
    </div>
    <VacancyListDeleteDialog
      v-if="deleteDialog"
      :vacancy-list="vacancyList"
      @closed="deleteDialog = false"
      @destroyed="destroyed()"
    />
    <VacancyListItemSocialDialog v-model="copyDialog" :link="showVacancyListUrl" />
  </div>
</template>

<script>
import moment from 'moment';
import { useI18n } from 'vue-i18n-composable';
import VacancyListQrLinks from '@/components/VacancyLists/VacancyListQrLinks';
import VacancyListQr from '@/components/VacancyLists/VacancyListQr';
import VacancyListDeleteDialog from '@/components/VacancyLists/VacancyListDeleteDialog';
import {
  computed, ref, toRefs,
} from '@vue/composition-api';
import VacancyListItemSocialDialog from '@/components/VacancyLists/VacancyListItemSocialDialog';

export default {
  name: 'VacancyListItem',
  components: {
    VacancyListItemSocialDialog, VacancyListDeleteDialog, VacancyListQr, VacancyListQrLinks,
  },
  props: {
    vacancyList: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit, root: { $router } }) {
    const { vacancyList } = toRefs(props);
    const deleteDialog = ref(false);
    const copyDialog = ref(false);
    const { locale, t } = useI18n();
    const showVacancyListUrl = computed(() => `${process.env.VUE_APP_APP_FRONT_URL}/qr/${vacancyList.value?.id}`);

    function getFontColor({ status }) {
      return status === 'active' ? 'black' : 'red';
    }

    // const vacancyListTitle = computed(() => {
    //   return vacancyList.value.title === 'Все вакансии' ? t('allVacancies') : vacancyList.value.title;
    // });

    const vacancyListTitle = computed(() => {
      return vacancyList.value.title;
    });

    function getFormattedDate(date) {
      if (!date) {
        return '';
      }

      if (locale.value.toLowerCase() === 'ru') {
        return moment(date)
          .locale(locale.value.toLowerCase()).format('DD.MM.YYYY');
      }

      return moment(date)
        .locale(locale.value.toLowerCase()).format('MM/DD/YYYY');
    }

    function onUpdate(id) {
      $router.push({ name: 'qr-detail', params: { id } });
    }

    function getUpdateLink(id) {
      return { name: 'qr-detail', params: { id } };
    }

    function destroyed() {
      deleteDialog.value = false;
      emit('destroyed');
    }

    function toggleVacancyListSocialDialog() {
      copyDialog.value = !copyDialog.value;
    }

    function toggleVacancyListDeleteDialog() {
      deleteDialog.value = !deleteDialog.value;
    }

    return {
      getFormattedDate,
      onUpdate,
      destroyed,
      deleteDialog,
      getFontColor,
      getUpdateLink,
      showVacancyListUrl,
      copyDialog,
      toggleVacancyListSocialDialog,
      toggleVacancyListDeleteDialog,
      vacancyListTitle,
    };
  },
};
</script>

<style lang="scss" scoped>
.vacancy-list-item {
  background: #FFFFFF;
  box-shadow: 0 2px 0.5rem rgba(0, 0, 0, 0.16);
  border-radius: 0.625rem;
  margin-bottom: 1.25rem;
  position: relative;
  &.no-active {
    border: 1px solid rgba(234, 13, 13, 0.4);
  }
  &__wrap {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
    padding: 30px;
  }
  &__vacancy-wrap {
    @media screen and (max-width: 1060px) {
      margin-top: 20px;
    }
  }
  &__qr-wrap {
    display: flex;
    margin-right: 1.5rem;
  }
  &__left-wrap {
    display: flex;
    width: 45%;
    @media screen and (max-width: 1060px) {
      flex-direction: column;
    }
  }
  &__title {
    font-size: 1.125rem;
    line-height: 1.11;
    color: #0A82D9;
    margin-bottom: 0.625rem;
    @media screen and (max-width: 1060px) {
      position: absolute;
      right: 20px;
      top: 20px;
    }
    a {
      text-decoration: none;
    }
  }
  &__list {
    min-width: 27rem;
  }
  &__list-error {
    display: flex;
    width: 100%;
    align-items: center;
    margin-bottom: 0.625rem;
    img {
      max-width: 1rem;
      max-height: 1rem;
      margin: 0 0.375rem 2px 0;
    }
  }
  &__list-error-icon {
    width: 1.0625rem;
    min-width: 1.0625rem;
    max-width: 1.0625rem;
    margin-right: 0.5rem;
  }
  &__list-error-text {
    font-size: 0.875rem;
    line-height: 1.2;
    color: #EA0D0D;
  }
  &__list-item {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    position: relative;
    color: #212121;
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 1.43;
    margin-bottom: 0.25rem;
    &:after {
      content: '';
      background: url("../../assets/img/account/plan/dashboard-details-bg.svg") center;
      width: 100%;
      height: 1px;
      min-height: 1px;
      position: absolute;
      left: 0;
      bottom: 0.375rem;
      z-index: 1;
    }
    &_error {
      color: #EA0D0D;
      .vacancy-list-item__list-caption:after, .vacancy-list-item__list-value:after {
        content: '';
        width: 100%;
        height: 1px;
        background: url("../../assets/img/qr/vacancy-list-error-bg.svg") center;
        position: absolute;
        left: 0;
        bottom: 0.25rem;
        opacity: 0.5;
      }
    }
  }
  &__list-caption {
    background: #FFFFFF;
    position: relative;
    z-index: 2;
  }
  &__list-value {
    min-width: 5.75rem;
    background: #FFFFFF;
    position: relative;
    z-index: 2;
    margin-left: 0.5rem;
  }
}
@media #{map-get($display-breakpoints, 'md-and-down')} {
  .vacancy-list-item {
    &__wrap {
      display: block;
      padding-right: 13.5rem;
      padding: 20px;
    }
    &__list {
      width: 100%;
      max-width: 27rem;
    }
    &__vacancy-wrap {
      flex-grow: 2;
    }
  }
}
@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .vacancy-list-item {
    &__wrap {
      padding-right: 0;
      padding: 15px;
    }
    &__qr-wrap {
      margin-right: 1.5rem;
    }
    &__vacancy-wrap {
      margin-right: 0;
    }
    &__list {
      min-width: inherit;
    }
    &__list-error {
      align-items: center;
    }
  }
}

</style>

<i18n lang="yml" locale="ru">
until: до
allVacanciesArchived: Все вакансии из этой подборки перешли в архив
emptyVacancies: В этой подборке нет вакансий
filterTitle: Подборка вакансий
filter.all: Все вакансии
filter.address: Вакансии по адресу
filter.list: Выбрать вручную
allVacancies: Все вакансии
</i18n>
<i18n lang="yml" locale="en">
unlil: until
show: View
update: Edit
delete: Delete
allVacanciesArchived: All jobs in this selection have been archived
emptyVacancies: There are no jobs in this selection
filterTitle: Jobs selection
filter.all: All jobs
filter.address: By address
filter.list: Hand-pick jobs
allVacancies: All jobs
</i18n>
